import { render, staticRenderFns } from "./LoanNavOverview.vue?vue&type=template&id=1181705a&scoped=true&"
import script from "./LoanNavOverview.vue?vue&type=script&lang=ts&"
export * from "./LoanNavOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181705a",
  null
  
)

export default component.exports